import { render, staticRenderFns } from "./HackernewsTrending.vue?vue&type=template&id=2823e7ce&scoped=true"
import script from "./HackernewsTrending.vue?vue&type=script&lang=js"
export * from "./HackernewsTrending.vue?vue&type=script&lang=js"
import style0 from "./HackernewsTrending.vue?vue&type=style&index=0&id=2823e7ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2823e7ce",
  null
  
)

export default component.exports